export default {
  'SET_AUTOMATIONS_LOG_TIME_FRAMES'(state, data) {
    state.automationsLogTimeFrames = data;
  },
  'SET_AUTOMATION_LOG_TIMESTAMP_START'(state, data) {
    state.automationLogTimestampStart = data;
  },
  'SET_AUTOMATIONS_LOG'(state, data) {
    state.automationsLog = data;
  },
  'SET_AUTOMATIONS_LOG_FILTER_TIME_FRAME_TAG'(state, data) {
    state.automationsLogFilters.timeFrameTag = data;
  }
};